module.exports = __webpack_public_path__ + "img/hero-1-bottom-shape.a75ade8a.png";